module.exports = __webpack_public_path__ + "static/media/jetSki-large.87e89737.png";